import { useEffect, useRef, useState } from "react";
import { showErrorNotification, showSuccessNotification } from "../../../components/admin/common/NotiService";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import { Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { deleteDialerById, getDialerList } from "../../../services/api-service";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import DialerForm from "./DialerForm";
import DeleteDialog from "../../../components/admin/common/CustomDeleteDialog";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import { writeAccess } from "../../../services/page-service";

export default function Dialers() {

    const [dialerData, setDialerData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showForm, setShowForm] = useState({ isNew: false, show: false });
    const [loading, setLoading] = useState(false);

    const [dialergridRef, setDialerGridRef] = useState(null);

    useEffect(() => {
        getDialerListFunction();
    }, []);

    async function getDialerListFunction() {
        setLoading(true);
        try {
            const resp = await getDialerList();

            if (resp?.Status === "Success" && resp?.Data) {
                setDialerData(resp.Data);
            } else {
                setDialerData([]);
            }

        } catch (e) {
            showErrorNotification("Error fetching Dialer list");
            setDialerData([]);
        }
        setLoading(false);
    }

    function onClickRow(rowItem) {
        setSelectedRow(rowItem.data);
        setShowForm({ isNew: false, show: true });
    }

    async function deleteDialer(name) {
        setLoading(true);
        try {
            const response = await deleteDialerById(name);

            if (response?.Status === "Success") {
                showSuccessNotification(response.Message);
                getDialerListFunction();
            } else {
                showErrorNotification(response?.Message || "Delete failed");
            }
        } catch (e) {
            showErrorNotification("Error deleting dialer");
        }
        setLoading(false);
    }

    const ActionsRenderer = (props) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const [deleteMode, setDeleteMode] = useState(false);
        const iconRef = useRef(null);

        const handleOpen = (e) => {
            e.stopPropagation();
            setAnchorEl(iconRef.current);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const onClickDelete = () => {
            setAnchorEl(null);
            setDeleteMode(true);
        };

        const onConfirmDelete = () => {
            deleteDialer(props.data.dialerName);
            setDeleteMode(false);
        };

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%"
                }}
            >
                {writeAccess() && (
                    <>
                        <img
                            ref={iconRef}
                            src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`}
                            alt="more"
                            style={{ cursor: "pointer" }}
                            onClick={handleOpen}
                        />

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={onClickDelete}>Delete</MenuItem>
                        </Menu>
                    </>
                )}

                {deleteMode && (
                    <DeleteDialog
                        title="Delete Dialer"
                        content={`This will completely delete (${props.data.dialerName}) Dialer permanently. You cannot undo this action.`}
                        open={true}
                        onClose={() => setDeleteMode(false)}
                        deleteFunction={onConfirmDelete}
                    />
                )}
            </div>
        );
    };

    const columnDefs = [
        { headerName: 'Dialer Name', field: 'dialerName', flex: 1 },
        { headerName: 'Dialer IP', field: 'dialerIp', flex: 1 },
        {
            headerName: '',
            field: 'actions',
            cellRenderer: ActionsRenderer,
            width: 70,
            maxWidth: 70,
            sortable: false,
            filter: false,
            suppressMenu: true,
        }
    ];

    return (
        <div className="oz-administration-container">

            <Stack direction="row" sx={{ marginBottom: 2 }}>
                <Typography sx={{ fontWeight: 600, fontSize: '24px' }} flexGrow={1}>
                    Dialers
                </Typography>

                {writeAccess() && (
                    <Button
                        variant="contained"
                        startIcon={<AddBoxOutlinedIcon />}
                        onClick={() => {
                            setSelectedRow(null);
                            setShowForm({ isNew: true, show: true });
                        }}
                    >
                        New Dialer
                    </Button>
                )}
            </Stack>

            <OZGridToolbar
                title="List of Dialers"
                rowCount={dialerData.length}
                dataGridRef={dialergridRef}
                hideDownload={true}
            />

            {loading ? (
                <LoadingScreen />
            ) : (
                <OZDataGrid
                    columns={columnDefs}
                    data={dialerData}
                    setGridRef={setDialerGridRef}
                    rowClickCallback={writeAccess() ? onClickRow : null}
                />
            )}

            {showForm.show && (
                <DialerForm
                    isNew={showForm.isNew}
                    data={showForm.isNew ? null : selectedRow}
                    onClose={() => setShowForm({ isNew: false, show: false })}
                    refreshList={getDialerListFunction}
                    deleteDialer={deleteDialer}
                />
            )}
        </div>
    );
}